export * from './modal-contract.component'